import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  QueryKey,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStaffService } from '../../../../apis/staff/useStaffService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TAttendanceByUserResponse } from '../../../../apis/__shared/attendance.interfaces';
import { Dayjs } from 'dayjs';

type TQueryError = IFHError<{ message: string }>;
export const getStaffAttendanceByUserKey = 'get-staff-attendance-by-user';

export const useStaffAttendanceByUserHook = (
  params: TPaginationParams,
  dateRange: { fromDate: Dayjs | null; toDate: Dayjs | null },
  staffId?: string,
  options?: Omit<UseQueryOptions<TAttendanceByUserResponse, TQueryError, TAttendanceByUserResponse, QueryKey>, 'queryKey' | 'queryFn'>
): UseQueryResult<TAttendanceByUserResponse, TQueryError> => {
  const { getStaffAttendanceByUser } = useStaffService();

  const queryKey = [getStaffAttendanceByUserKey, params, dateRange, staffId];

  return useQuery<TAttendanceByUserResponse, TQueryError>({
    queryKey,
    queryFn: () => getStaffAttendanceByUser(params, dateRange, staffId),
    enabled: true,
    ...options,
  });
};

